import React, { Component } from "react"
import { connect } from "react-redux"
import { Spin, Row, Col } from "antd"
import {
    fetchAllPatientFolders,
    updatePatientFolderSearchParams,
    clearPatientFolderSearchParams
} from "redux_actions/patientfolder.state.action"
import PatientFolderTable from "component/patientfolder/PatientFolderTable"
import CreateAndSearchBar from "component/patientfolder/CreateAndSearchBar"
import PatientFolderActions from "component/patientfolder/PatientFolderActions"
import { loadUsers } from "redux_actions/cases.action"
import { openEndPoint } from "utils/utils"
import AddCaseButton from "component/patientfolder/case/AddCaseButton"

import "asset/style/dashboard.css"
import "asset/style/custom_antd_table_style.css"
import HistoryLink from "component/common/HistoryLink"
import { getFolderEndpoint } from "utils/endpoint_utils"

class PatientFolderView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            searchFolderName: [],
            searchTag: [],
            selectedRowKeys: [],
            selectedRows: [],
        }

        this.fetchAllFoldersTimeoutId = null
    }

    componentDidMount() {
        fetchAllPatientFolders()
        this.props.dispatch(loadUsers())
    }

    componentDidUpdate(prevProp, prevState) {
        if (prevState.searchFolderName !== this.state.searchFolderName) {
            this.props.dispatch(updatePatientFolderSearchParams({
                 folder_name__iregex: this.startsWithRegex(this.state.searchFolderName) || undefined
            }))
            this.fetchAllFolders()
        }

        if (prevState.searchTag !== this.state.searchTag) {
            this.props.dispatch(updatePatientFolderSearchParams({
                tags: this.state.searchTag.map(tag => tag.slice(1))
            }))
            this.fetchAllFolders()
        }
    }

    startsWithRegex = (list) => list.map(e => `^${e}`).join('|')

    fetchAllFolders = () => {
        if (this.fetchAllFoldersTimeoutId !== null) {
            clearTimeout(this.fetchAllFoldersTimeoutId)
        }

        this.fetchAllFoldersTimeoutId = setTimeout(() => {
            fetchAllPatientFolders()
            this.fetchAllFoldersTimeoutId = null
        }, 1000)
    }

    handleSearch = (value) => {
        if (value.trim().length < 1) return

        const key = value.startsWith("#") ? "searchTag" : "searchFolderName"
        this.setState(state => ({
            ...state,
            [key]: [value, ...state[key]],
            selectedRows: []
        }))
    }

    handleDeselect = (value) => {
        if (value.trim().length < 1) return
        
        const key = value.startsWith("#") ? "searchTag" : "searchFolderName"
        this.setState(state => ({
            ...state,
            [key]: state[key].filter(v => v !== value)
        }))
    }

    handleReset = () => {
        this.props.dispatch(clearPatientFolderSearchParams())
        this.setState({ searchFolderName: [], searchTag: [], selectedRows: [] })
    }

    handleClearSelect = () => this.setState({ selectedRows: [], selectedRowKeys: [] })

    handleCreate = () => openEndPoint("/addpatientfolder/")

    handleRowSelect = (selectedRowKeys, selectedRows) => this.setState({ selectedRowKeys, selectedRows })

    historyLinks = [
        {
            label: "Folders",
            link: getFolderEndpoint()
        }
    ]

    render() {
        return this.props.isFetching ?
            <Spin tip={"Loading..."} spinning={this.props.isFetching} delay={500} /> :
            <Row>
                <div className="history-link-wrapper">
                    <HistoryLink links={this.historyLinks} />
                </div>

                <Col span={24} offset={0} className="all-slides">
                    <CreateAndSearchBar
                        title={"Folder"}
                        searchSelected={[ ...this.state.searchFolderName, ...this.state.searchTag ]}
                        handleSearch={this.handleSearch}
                        handleDeselect={this.handleDeselect}
                        handleReset={this.handleReset}
                        CreateButton={<AddCaseButton />}
                    />
                </Col>
                <Col span={24} offset={0} className="all-slides">
                    <PatientFolderActions
                        selectedRows={this.state.selectedRows}
                        handleCancelSelect={this.handleClearSelect}
                    />
                </Col>
                <Col span={24} offset={0} className="all-slides">
                    <PatientFolderTable
                        selectedRowKeys={this.state.selectedRowKeys}
                        selectedRows={this.state.selectedRows}
                        handleRowSelect={this.handleRowSelect}
                    />
                </Col>
            </Row>
    }
}

const mapStateToProps = (state) => ({
    allPatientFolders: state.patientfolderReducer.allPatientFolders,
    searchParams: state.patientfolderReducer.searchParamsMap,
    page: state.patientfolderReducer.page,
    totalPage: state.patientfolderReducer.totalPage,
})

export default connect(mapStateToProps)(PatientFolderView)